<template>
    <div class="mt-5">
        <AppWell :class="selectedItems.length ? 'visible' : 'invisible'">
            <div class="flex space-x-2 mt-5 items-start">
                <AppButton @click="giveItems()" element="button" desired-action>
                    {{ $tc('messages.give_items', selectedItems.length) }}
                </AppButton>

                <div>
                    <input
                        id="buy"
                        type="checkbox"
                        v-model="form.is_purchase"
                        name="buy"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                    <FormLabel :value="$t('messages.buy')" for="buy" />
                </div>
                <TransitionGroup
                    enter-active-class="transition-opacity ease-linear duration-300"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="transition-opacity ease-linear duration-300"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                    tag="div"
                    class="flex gap-1 flex-wrap"
                >
                    <div v-for="item in selectedItems" class="relative" :key="item.id">
                        <div
                            class="w-10 h-10 bg-gray-300 rounded-full shrink-0 relative bg-no-repeat bg-center bg-cover"
                            :style="`background-image: url(${item.image_path});`"
                        >
                            <BadgePill color="indigo" class="absolute right-0 bottom-0">
                                &times;{{ item.quantity }}
                            </BadgePill>
                        </div>
                    </div>
                </TransitionGroup>
            </div>
        </AppWell>
        <div>
            <FormInput
                id="search"
                v-model.trim="search"
                :placeholder="`${$t('messages.search')}: ${$tc('messages.gamification_items', 1)}`"
                type="text"
                class="mt-1 w-full"
                autocomplete="off"
            />
        </div>
        <EmptyState picture v-if="form.items.length === 0" />
        <div v-else>
            <TransitionGroup
                enter-active-class="transition-opacity ease-linear duration-300"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-opacity ease-linear duration-300"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
                tag="div"
                class="grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3 gap-3 md:gap-6 mt-5"
            >
                <div v-for="item in filteredItems" class="flex flex-col mt-5 sm:mt-0" :key="item.id">
                    <div class="text-sm">
                        <div class="flex space-x-2">
                            <label :for="`item_${item.id}`">
                                <span v-if="item.creates_foul">
                                    <svg
                                        class="inline-block h-4 w-4 text-gray-600 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                        stroke="none"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M18.615 3.13745H5.38496C4.11496 3.13745 3.08496 4.16745 3.08496 5.43745V18.6675C3.08496 19.9375 4.11496 20.9675 5.38496 20.9675H18.615C19.885 20.9675 20.915 19.9375 20.915 18.6675V5.43745C20.915 4.16745 19.885 3.13745 18.615 3.13745ZM19.715 18.6575C19.715 19.2675 19.225 19.7575 18.615 19.7575H5.38496C4.77496 19.7575 4.28496 19.2675 4.28496 18.6575V5.43745C4.28496 4.82745 4.77496 4.33745 5.38496 4.33745H18.615C19.225 4.33745 19.715 4.82745 19.715 5.43745V18.6575ZM12.5149 5.26758H11.4849C10.9749 5.26758 10.4749 5.48758 10.1249 5.87758C9.75494 6.28758 9.56494 6.85758 9.62494 7.41758L10.1349 12.4076C10.2349 13.3976 11.0349 14.1476 11.9949 14.1476C12.9549 14.1476 13.7449 13.3976 13.8549 12.4076L14.3649 7.41758C14.4249 6.84758 14.2449 6.28758 13.8649 5.87758C13.5249 5.49758 13.0249 5.26758 12.5149 5.26758ZM12.6649 12.2876C12.6249 12.6676 12.3449 12.9476 12.0049 12.9476C11.6649 12.9476 11.3849 12.6676 11.3449 12.2876L10.8349 7.29758C10.8149 7.06758 10.8849 6.84758 11.0249 6.67758C11.1549 6.53758 11.3149 6.45758 11.4949 6.45758H12.5249C12.7049 6.45758 12.8649 6.53758 12.9949 6.67758C13.1449 6.83758 13.2149 7.06758 13.1849 7.29758L12.6649 12.2876ZM10.205 16.9775C10.205 15.9875 11.015 15.1875 12.005 15.1875C12.995 15.1875 13.805 15.9875 13.805 16.9775C13.805 17.9675 12.995 18.7675 12.005 18.7675C11.015 18.7675 10.205 17.9675 10.205 16.9775ZM11.205 16.9775C11.205 17.4075 11.565 17.7675 12.005 17.7675C12.445 17.7675 12.805 17.4175 12.805 16.9775C12.805 16.5475 12.445 16.1875 12.005 16.1875C11.565 16.1875 11.205 16.5375 11.205 16.9775Z"
                                        />
                                    </svg>
                                </span>

                                {{ item.name }}
                            </label>
                        </div>
                    </div>
                    <div>
                        <IntegerPlusMinusInput min="0" max="5" v-model="item.quantity" />
                    </div>
                    <div class="mt-2">
                        <div
                            @click="giveItem(item)"
                            class="shrink-0 flex items-center justify-center h-16 w-full rounded-lg aspect-w-1 aspect-h-1"
                            :class="{ 'cursor-pointer': selectedItems.length === 0 }"
                        >
                            <img v-if="item.image_path" :src="item.image_path" alt="" />
                        </div>
                    </div>
                    <div class="flex mt-2">
                        <div>
                            <BadgePill color="yellow" class="text-lg" v-if="item.price !== null">
                                {{ item.price }}
                            </BadgePill>
                        </div>
                    </div>
                </div>
            </TransitionGroup>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import BadgePill from '@/components/BadgePill.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import IntegerPlusMinusInput from '@/components/Forms/IntegerPlusMinusInput.vue';
import deburr from 'lodash/deburr.js';
import AppWell from '@/Shared/AppWell.vue';

export default {
    emits: ['close'],
    name: 'GiveItemsForm',

    components: {
        EmptyState,
        BadgePill,
        FormLabel,
        AppButton,
        FormInput,
        AppWell,
        IntegerPlusMinusInput,
    },

    props: {
        students: {
            required: true,
            type: [Object, Array],
        },
        items: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            search: '',
            form: this.$inertia.form({
                is_purchase: false,
                items: this.items.map((item) => {
                    return {
                        id: item.id,
                        creates_foul: item.creates_foul,
                        name: item.name,
                        image_path: item.image_path,
                        price: item.price,
                        active: false,
                        quantity: 0,
                    };
                }),
            }),
        };
    },

    computed: {
        selectedStudentsIds: function () {
            return this.selectedStudents.map((s) => s.id);
        },
        selectedItems: function () {
            return this.form.items.filter((i) => !!i.quantity);
        },
        filteredItems: function () {
            if (this.search.trim().length === 0) {
                return this.form.items;
            }
            const search = deburr(this.search.toUpperCase());
            return this.form.items.filter((item) => {
                const nameWithoutAccents = deburr(item.name.toUpperCase());

                return nameWithoutAccents.includes(search) || item.quantity > 0;
            });
        },
        selectedStudents: function () {
            if (Array.isArray(this.students)) {
                return this.students;
            }

            if (typeof this.students === 'object') {
                return [this.students];
            }

            return this.students;
        },
    },

    methods: {
        giveItems() {
            if (this.selectedItems.length === 0) {
                return;
            }

            const url = route('gamification.give_items.store');
            this.form
                .transform((data) => {
                    data.student_ids = this.selectedStudentsIds;
                    data.items = this.selectedItems.map((i) => {
                        return {
                            id: i.id,
                            quantity: i.quantity,
                        };
                    });
                    return data;
                })
                .post(url, {
                    onSuccess: () => {
                        this.$emit('close');
                    },
                    preserveScroll: true,
                });
        },
        giveItem(item) {
            if (this.selectedItems.length > 0) {
                return;
            }

            const url = route('gamification.give_items.store');
            const data = {
                student_ids: this.selectedStudentsIds,
                is_purchase: this.form.is_purchase,
                items: [
                    {
                        id: item.id,
                        quantity: 1,
                    },
                ],
            };
            this.$inertia.post(url, data, {
                onSuccess: () => {
                    this.$emit('close');
                },
                preserveScroll: true,
            });
        },
    },
};
</script>
